import { useEffect, useState } from 'react'
import { api } from './api'

/**
 * Was jeder Vertragsstatus bedeutet.
 *
 * Die Texte stehen ein einziges Mal, im Backend (`Vertragsstatus.erklaerung`), und
 * kommen ueber `GET /api/vertraege/statuserklaerungen`; das Entwicklerpult liest
 * dieselben. Die Oberflaechen teilen kein Paket, und eine zweite Abschrift hier liefe
 * der ersten ueber kurz oder lang davon.
 *
 * Anders als `useAbruf` mit Zwischenspeicher: die Texte aendern sich nicht mit dem
 * Bestand, nur mit einer neuen Version der Anwendung.
 */
export type Statuserklaerungen = Record<string, string>

let geladen: Promise<Statuserklaerungen> | undefined

function lade(): Promise<Statuserklaerungen> {
  if (!geladen) {
    geladen = api
      .lies<Statuserklaerungen>('/api/vertraege/statuserklaerungen')
      .catch((ursache) => {
        // Beim naechsten Mal neu versuchen, statt den Fehler festzuhalten.
        geladen = undefined
        throw ursache
      })
  }
  return geladen
}

/** Die Erklaerungen; leer, bis sie geladen sind oder wenn die Anwendung nicht antwortet. */
export function useStatuserklaerungen(): Statuserklaerungen {
  const [erklaerungen, setzeErklaerungen] = useState<Statuserklaerungen>({})
  useEffect(() => {
    let abgebrochen = false
    lade()
      .then((ergebnis) => {
        if (!abgebrochen) {
          setzeErklaerungen(ergebnis)
        }
      })
      .catch(() => {
        /* Ohne Erklaerungen bleibt der Status lesbar; nur der Hover-Text fehlt. */
      })
    return () => {
      abgebrochen = true
    }
  }, [])
  return erklaerungen
}

/** Alle Status mit ihrer Erklaerung - aufklappbar unter der Statusauswahl. */
export function Statuslegende({
  erklaerungen,
  staende,
}: {
  erklaerungen: Statuserklaerungen
  staende: readonly string[]
}) {
  return (
    <details className="statuslegende">
      <summary>Was die Status bedeuten</summary>
      <dl>
        {staende.map((status) => (
          <div key={status}>
            <dt>{status}</dt>
            <dd>{erklaerungen[status] ?? '—'}</dd>
          </div>
        ))}
      </dl>
    </details>
  )
}
